import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
const SvgTimeCalendar = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    props,
    <path d="M8 3a1 1 0 0 0-2 0v1H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-2V3a1 1 0 1 0-2 0v1H8V3Zm11 5H5V6h14v2ZM5 10h14v10H5V10Z" />
  )
export default SvgTimeCalendar
